import { LoaderView } from './components'

export const Loader = ({ isActive }) => {
  if (!isActive) return null

  return <LoaderView />
}

export default Loader
